import { render, staticRenderFns } from "./MapackKanban.vue?vue&type=template&id=1fadff33"
import script from "./MapackKanban.vue?vue&type=script&lang=js"
export * from "./MapackKanban.vue?vue&type=script&lang=js"
import style0 from "./MapackKanban.vue?vue&type=style&index=0&id=1fadff33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports